export enum RecipeType {
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
}
